"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineDate = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineDate = (item, format = "DD/MM/YYYY") => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    return dayjs(latest_version.start_date).format(format);
};
exports.getOrderLineDate = getOrderLineDate;
